var Rfl = {
    mainCognitiveStatements:
        [[1,3,'Right','Left'], [3,9,'Bottom','Top'], [9,12,'Bottom','Top'], [12,16,'Bottom','Top'], [16,19,'Bottom','Top'],
            [19,21,'Bottom','Top'], [21,23,'Left','Right'], [23,26,'Bottom','Top'], [26,31,'Right','Top']],
    altCognitiveStatements:
        [[3,4,'Left','Top'], [3,6,'Bottom','Top'],[4,9,'Bottom','Top'], [9,10,'Right','Left'], [9,14,'Bottom','Top'],
            [10,14,'Bottom','Top'], [14,18,'Bottom','Top'],[14,23,'Bottom','Top'],[18,20,'Bottom','Top'],[20,23,'Bottom','Top'],[23,24,'Right','Left'],
            [24,26,'Left','Right'], [26,31,'Bottom','Top']],
    mainCommunicationStatements:
        [[1,2,'Left','Right'], [2,5,'Bottom','Top'], [5,9,'Right','Left'], [9,11,'Left','Top'], [11,13,'Left','Right'],
            [13,15,'Bottom','Top'],[15,17,'Bottom','Top'],[17,23,'Bottom','Top'],[23,26,'Bottom','Top'], [26,32,'Bottom','Top']],
    altCommunicationStatements:
        [[5,7,'Bottom','Top'], [7,8,'Right','Left'], [8,9,'Right','Left'], [11,15,'Bottom','Right'], [15,23,'Right','Top'],
            [23,25,'Bottom','Right'], [25,26,'Right','Left'], [17,22,'Bottom','Top'], [22,23,'Right','Left'], [26,28,'Right','Left']],

    mainCognitiveColour: '#0288d1',
    altCognitiveColour: '#00BFFF',
    mainCommunicationColour: '#D32F2F',
    altCommunicationColour: '#EF8C28',

    init: function() {
        Rfl.bindTutorGroup();
        Rfl.bindStatementCheckBoxes();
        Rfl.initArrows();
        Rfl.bindPrint();
        Rfl.bindYearSelect();
        Rfl.bindCopy();
        Rfl.bindRflDates();
        Rfl.bindClearDate();
    },

    initArrows: function() {
        Rfl.drawArrows('mainCognitive');
        Rfl.drawArrows('altCognitive');
        Rfl.drawArrows('mainCommunication');
        Rfl.drawArrows('altCommunication');
        Rfl.showArrows();
        Rfl.bindRouteChecks();
    },

    showArrows: function() {
        if (mainCognitive == 1) {
            $('.mainCognitive').show();
        }
        if (altCognitive == 1) {
            $('.altCognitive').show();
        }
        if (mainCommunication == 1) {
            $('.mainCommunication').show();
        }
        if (altCommunication == 1) {
            $('.altCommunication').show();
        }
    },

    bindCopy: function() {
        $('#rfl-copy').click(function() {
            var pupilId = $('#pupilId').val();
            var tutorGroupId = $('#tutorGroupId').val();
            var year = $('#filterYear').val();
            var copy = confirm('Are you sure? This will remove any existing mappings for the target year.');
            if (copy) {
                $.get('/rfl/' + tutorGroupId + '/' + pupilId + '/copy?year=' + year, function(response) {
                    if (response.success) {
                        alert('Mappings have been successfully copied!');
                    }
                })
            }
        });
    },

    bindYearSelect: function() {
        $('#rfl-year').on('change', function() {
            window.location.href = window.location.pathname + '?year=' + $(this).val();
        });
    },

    bindPrint: function() {
        $('#rfl-print').click(function() {
            var cog1 = $('#mainCognitive:checked').length;
            var cog2 = $('#alternativeCognitive:checked').length;
            var com1 = $('#mainCommunication:checked').length;
            var com2 = $('#alternativeCommunication:checked').length;
            var tutorGroupId = $('#tutorGroupId').val();
            var pupilId = $('#pupilId').val();
            window.open('/rfl/' + tutorGroupId + '/' + pupilId + '?pdf=1&cog1=' + cog1 + '&cog2=' + cog2 + '&com1=' + com1 + '&com2=' +com2, '_blank');
            //window.print();
        });
    },

    bindTutorGroup: function() {
        $('#rfl-tutor-groups').on('change', function() {
            var tutorGroupId = $(this).val();
            window.location.href = '/rfl/' + tutorGroupId;
            // $.get('/rfl/' + tutorGroupId, function(data){
            //    $('#rfl-pupils').html(data);
            // });
        });
    },

    bindRouteChecks: function() {
        $('.rfl-route-check').click(function() {
            var route = $(this).val();
            var routeElements = $('.' + route);
            if ($(this).prop('checked')) {
                routeElements.show();
                return;
            }
            routeElements.hide();
        });
    },

    bindRflDates: function() {
        $('.rfl-date').change(function() {
            var input = $(this);
            var sortOrder = input.data('sort-order');
            var dateContainer = $('#rfl-date-container-' + sortOrder);
            var pupilId = input.data('pupil-id');
            var statementId = input.data('statement-id');
            var year = $('#rfl-year').val();
            var date = 0;
            var dateInputVal = $('#rfl-date-' + sortOrder).val();
            if (dateInputVal !== 'No date set.') {
                date = dateInputVal;
            }
            var savedText = $('#rfl-saved-' + sortOrder);
            var url = '/rfl-statements/update?pupilId=' + pupilId + '&statementId=' + statementId + '&year=' + year + '&date=' + date;
            $.get(url, function(data) {
                if (data.success) {
                    dateContainer.addClass('has-date');
                    savedText.slideDown('fast');
                    setTimeout(function () {
                        savedText.slideUp('fast');
                    }, 750);
                    return;
                }
            });
        });
    },

    bindClearDate:function() {
        $('.clear-date').click(function() {
            var btn = $(this);
            var sortOrder = btn.data('sort-order');
            var dateInput = $('#rfl-date-' + sortOrder);
            var dateContainer = $('#rfl-date-container-' + sortOrder);
            var pupilId = btn.data('pupil-id');
            var statementId = btn.data('statement-id');
            var year = $('#rfl-year').val();
            var url = '/rfl-statements/update?pupilId=' + pupilId + '&statementId=' + statementId + '&year=' + year;
            var savedText = $('#rfl-saved-' + sortOrder);
            $.get(url, function(data) {
                if (data.success) {
                    dateContainer.removeClass('has-date');
                    savedText.slideDown('fast');
                    setTimeout(function () {
                        savedText.slideUp('fast');
                    }, 750);
                    dateInput.val('No date set.');
                    return;
                }
            });
        });
    },

    bindStatementCheckBoxes: function() {
        $('.rfl-statement-select').click(function() {
            var checkBox = $(this);
            var sortOrder = checkBox.data('sort-order');
            var container = $('#rfl-sort-order-' + sortOrder);
            var pupilId = checkBox.data('pupil-id');
            var statementId = checkBox.data('statement-id');
            var action = 'select';
            var year = $('#rfl-year').val();
            var date = 0;
            var dateInputVal = $('#rfl-date-' + sortOrder).val();
            if (dateInputVal !== 'No date set.') {
                date = dateInputVal;
            }
            var url = '/rfl-statements/select?pupilId=' + pupilId + '&statementId=' + statementId + '&year=' + year + '&date=' + date;
            var savedText = $('#rfl-saved-' + sortOrder);

            container.removeClass('deselected');
            if (!checkBox.prop('checked')) {
                action = 'deselect';
                url = '/rfl-statements/deselect?pupilId=' + pupilId + '&statementId=' + statementId + '&year=' + year + '&date=' + date;
                container.addClass('deselected');
            }
            $.get(url, function(data) {
                if (data.success) {
                    savedText.slideDown('fast');
                    setTimeout(function() {
                        savedText.slideUp('fast');
                    }, 750);
                    return;
                }
                alert('Failed to ' + action + ' statement, please try again.');
            })
        });
    },

    drawArrows: function(type) {
        jsPlumb.ready(function() {
            var prefix = 'rfl-sort-order-';
            var statementConnections = Rfl.mainCognitiveStatements;
            var arrowColour = Rfl.mainCognitiveColour;
            switch (type) {
                case "altCognitive":
                    statementConnections = Rfl.altCognitiveStatements;
                    arrowColour = Rfl.altCognitiveColour;
                    break;
                case "mainCommunication":
                    statementConnections = Rfl.mainCommunicationStatements;
                    arrowColour = Rfl.mainCommunicationColour;
                    break;
                case "altCommunication":
                    statementConnections = Rfl.altCommunicationStatements;
                    arrowColour = Rfl.altCommunicationColour;
                    break;
            }
            var common = {
                cssClass: type + ' arrow',
                connector: ["Straight"],
                endpoint: ["Dot", {radius:5, cssClass: type + ' endPoint'}],
                anchor: ["left", "right"], //Default anchors
            };
            for (var x = 0; x < statementConnections.length; x++) {
                var currentPair = statementConnections[x];
                try {
                    var from = currentPair[0];
                    var to = currentPair[1];
                    common.anchor = [currentPair[2], currentPair[3]];
                    jsPlumb.connect({
                        source: prefix + from,
                        target: prefix + to,
                        paintStyle:{ strokeStyle: arrowColour, lineWidth: 6, },
                        endpointStyle:{ fillStyle:arrowColour, },
                        overlays:[
                            ["Arrow" , { width:15, length:12, location:0.67 }]
                        ]
                    }, common);
                }
                catch(err) {
                    continue;
                }
            }
        });
    },
}